import React from "react";
import styles from "./Contacts.module.scss";
import Layout from "../../layouts/Layout/Layout";
import { ContactForm } from "../../ui";
import { Button } from "../../elements";
import { useCustomState } from "../../../state/state";

export default () => {
  const state = useCustomState()[0];

  return (
    <Layout
      style={{
        background:
          "url(" + state.data.header_bgs.contacts_w + ") center/cover",
      }}
      mode="dark"
      col="2"
      padding
    >
      <ContactForm />
      <div className={styles.wrapper}>
        <div className={styles.contact_info}>
          <h2>Contact us.</h2>
          {/* <p>
           We believe in our team. We can provide to you strategic solutions to any problem in these industries, having direct impact on the bottom line.
          </p> */}
          <Button
            to="/contacts"
            type="solid-color-tb"
            hoverType="solid-white-tb"
            after="&#xf105;"
          />
        </div>
      </div>
    </Layout>
  );
};
